import AddIcon from '@material-ui/icons/Add';
import React, { useState } from 'react';
import { Button } from '../common/Button';
import { Dialog } from '../common/Dialog';
import { createFolder } from '../services/UploadManagementService';
import { Folder, isFolder, RootFolder } from '../services/UploadManagementServiceTypes';
import { CreateFolderModal } from './CreateFolderModal';

export interface CreateFolderProps {
  currentFolder: RootFolder | Folder;
  getFolderListing: () => void;
}

export const CreateFolder: React.FunctionComponent<CreateFolderProps> = ({
  currentFolder,
  getFolderListing,
}) => {
  const [open, setState] = useState(false);

  const handleOnClick = () => setState(true);
  const handleOnModalClose = () => setState(false);

  return (
    <>
      <Button variant='outlined' startIcon={<AddIcon />} onClick={handleOnClick}>
        New Folder
      </Button>

      <Dialog open={open} onClose={handleOnModalClose}>
        <CreateFolderModal
          onSuccess={() => {
            handleOnModalClose();
            getFolderListing();
          }}
          onClose={handleOnModalClose}
          createFolderAction={(folderName) =>
            createFolder({
              name: folderName,
              parentGuid: isFolder(currentFolder) ? currentFolder.guid : null,
            })
          }
        />
      </Dialog>
    </>
  );
};
